import { gql } from "@apollo/client";

export const GET_ALL_VENDORS = gql`
  query GetAllVendors($where: vendors_bool_exp) {
    vendors(where: $where, order_by: { name: asc }) {
      id
      name
      is_active
    }
  }
`;

export const GET_WORKERS_BY_VENDOR = gql`
  query GetWorkersByVendor($where: workers_bool_exp!) {
    workers(where: $where, order_by: { name: asc }) {
      id
      vendor_id
      event_id
      name
      hourly_rate
      pin
      phone
      is_active
      created_at
      updated_at
      worker_role_assignments {
        worker_role {
          id
          name
        }
      }
      timeclock_entries_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

export const GET_ROLES_BY_VENDOR = gql`
  query GetRolesByVendor($vendorId: Int!) {
    worker_roles(where: { vendor_id: { _eq: $vendorId } }, order_by: { name: asc }) {
      id
      vendor_id
      name
      is_active
      created_at
      updated_at
      worker_role_assignments_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

export const GET_EVENTS_FOR_VENDOR = gql`
  query GetEventsForVendor($vendorId: Int!) {
    locations(where: { vendor_id: { _eq: $vendorId }, is_active: { _eq: true } }) {
      event_id
      event {
        id
        name
      }
    }
  }
`;

export const GET_EVENTS_FOR_ORG = gql`
  query GetEventsForOrg($where: events_bool_exp) {
    events(where: $where, order_by: { name: asc }) {
      id
      name
    }
  }
`;

export const GET_ACTIVE_SHIFTS_BY_VENDOR = gql`
  query GetActiveShiftsByVendor($where: timeclock_entries_bool_exp!) {
    timeclock_entries(
      where: $where
      order_by: { clock_in: asc }
    ) {
      id
      worker_id
      event_id
      clock_in
      worker {
        id
        name
        hourly_rate
      }
      event {
        id
        name
      }
    }
  }
`;

export const GET_TIMECLOCK_SUMMARY_BY_VENDOR = gql`
  query GetTimeclockSummary($where: timeclock_entries_bool_exp!) {
    timeclock_entries(where: $where, order_by: { clock_in: desc }) {
      id
      worker_id
      event_id
      clock_in
      clock_out
      worker {
        id
        name
        hourly_rate
        vendor_id
      }
    }
  }
`;

export const GET_TIMECLOCK_ENTRIES_BY_EVENT = gql`
  query GetTimeclockEntriesByEvent($vendorId: Int!, $eventId: Int!) {
    timeclock_entries(
      where: { worker: { vendor_id: { _eq: $vendorId } }, event_id: { _eq: $eventId } }
      order_by: { clock_in: desc }
    ) {
      id
      worker_id
      event_id
      clock_in
      clock_out
      created_at
      updated_at
      worker {
        id
        name
        hourly_rate
      }
    }
  }
`;

export const GET_TIMECLOCK_SETTINGS = gql`
  query GetTimeclockSettings($vendorId: Int!) {
    timeclock_settings(where: { vendor_id: { _eq: $vendorId } }, limit: 1) {
      vendor_id
      require_pin
    }
  }
`;

export const GET_CLERKS_FOR_ORG = gql`
  query GetClerksForOrg($organizationId: Int!) {
    users(
      where: {
        role_id: { _eq: 3 }
        organization_id: { _eq: $organizationId }
        is_active: { _eq: true }
      }
      order_by: { first_name: asc }
    ) {
      id
      first_name
      last_name
      username
      email
      phone_number
    }
  }
`;
